<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailMateriel.format.title') }}
      </p>
    </header>
    <div class="card-content columns is-multiline">
      <div class="column is-3">
        <b-field :label="$t('detailMateriel.format.format')" custom-class="has-text-link">
          <p>{{ materiel.format.libelle }}</p>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailMateriel.format.surfaceCommerciale')"
                 custom-class="has-text-link mgb-5px">
          {{ getSurfaceCommerciale !== null ?
          $t('detailMateriel.tlpe.m2', { surface: getSurfaceCommerciale }) : '' }}
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailMateriel.format.surfaceCommercialePerso')"
                 custom-class="has-text-link mgb-5px">
          {{ materiel.surface.surfaceCommerciale !== null ? $t('detailMateriel.tlpe.m2', {
          surface: materiel.surface.surfaceCommerciale }) : '' }}
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'MaterielDetailFormat',
  props: {
    materiel: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    materielFormat() {
      return this.parametre(PARAMETRES_KEYS.materielFormat);
    },
    getSurfaceCommerciale() {
      const formatFind = this.materielFormat.find((materielFormat) => {
        return materielFormat.id === this.materiel.formatId;
      });
      return formatFind ? formatFind.surface.surfaceCommerciale : null;
    },
  },
};

</script>
